import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

/**
 * API för att hantera samtycke för kreditupplysning
 */

export type ConsentErrorCode = 'TOKEN_NOT_FOUND' | 'CONSENT_ALREADY_GIVEN' | 'LINK_EXPIRED' | 'INTERNAL_ERROR';

export interface ValidateTokenResponse {
  success: boolean;
  data?: {
    id: string;
    tenantFirstName: string;
    tenantLastName: string;
    tenantEmail: string;
    apartmentNumber: string;
    address: string;
    city: string;
    zipCode: string;
  };
  error?: string;
  errorCode?: ConsentErrorCode;
}

export interface GiveConsentResponse {
  success: boolean;
  message?: string;
  error?: string;
}

/**
 * Validera en consent-token
 */
export async function validateConsentToken(token: string): Promise<ValidateTokenResponse> {
  try {
    const validateToken = httpsCallable<{ token: string }, ValidateTokenResponse>(
      functions,
      'validateConsentToken'
    );

    const result = await validateToken({ token });
    return result.data;
  } catch (error: any) {
    console.error('Error validating consent token:', error);
    return {
      success: false,
      error: error.message || 'Ett fel uppstod vid validering av token'
    };
  }
}

/**
 * Ge samtycke för kreditupplysning
 */
export async function giveConsentForCreditCheck(token: string): Promise<GiveConsentResponse> {
  try {
    const giveConsent = httpsCallable<{ token: string }, GiveConsentResponse>(
      functions,
      'giveConsent'
    );

    const result = await giveConsent({ token });
    return result.data;
  } catch (error: any) {
    console.error('Error giving consent:', error);
    return {
      success: false,
      error: error.message || 'Ett fel uppstod när samtycket skulle sparas'
    };
  }
}

